import { Box } from "@mui/material";

import useDining from "./dining-hooks";
import { HeaderLayout, Layout } from "../InRoomDining";
import { FullScreenLoader, ServiceCard } from "../../components";

const DiningMenu = () => {
  const { dining, loading } = useDining();

  if (loading) {
    return <FullScreenLoader />;
  }

  return (
    <Layout>
      <HeaderLayout title="Dining" />
      <Box
        sx={{
          p: 2,
          pt: 0,
          flex: 1,
          overflow: "auto",
          background: "#F4F4F4",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {Array.isArray(dining) &&
          dining?.find((service)=>service.name==="Restaurants")?.sub_services?.map((hotelService: any) => {
            return (
              <ServiceCard
                showInfo={true}
                key={hotelService?.name}
                label={hotelService?.name}
                description={hotelService?.desc}
                image={hotelService?.img as string}
                serviceID={hotelService?.service_id}
              />
            );
          })}
      </Box>
    </Layout>
  );
};

export default DiningMenu;
